module.exports = __webpack_public_path__ + "img/12.2e6acd07.jpg";